const convertToUSCurrency = (
  priceToBeConverted: number,
  minimumFractionDigits = 2
) => {
  if (priceToBeConverted === null) return '-'
  else {
    let currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits,
    })
    return currencyFormatter.format(priceToBeConverted)
  }
}

export { convertToUSCurrency }
